import BaseModel from '@/bundles/App/models/BaseModel';
import { IAdCampaign, IAdCampaignItem, IAdClient } from '@/bundles/Ad/interfaces';
import { Nullable } from '@/bundles/App/type';
import { AdCampaignStatus } from '@/bundles/Ad/types';
import AdClient from '@/bundles/Ad/models/AdClient';
import AdCampaignItem from '@/bundles/Ad/models/AdCampaignItem';

export default class AdCampaign extends BaseModel implements IAdCampaign {
  active: boolean;
  client: IAdClient;
  description: Nullable<string>;
  region: string;
  status: AdCampaignStatus;
  title: string;
  items: IAdCampaignItem[];

  constructor (props: IAdCampaign) {
    super(props);
    this.active = props.active;
    this.client = new AdClient(props.client);
    this.description = props.description;
    this.region = props.region;
    this.status = props.status;
    this.title = props.title;
    this.items = props.items?.map((item) => new AdCampaignItem({ ...item})) || [];
  }
}
